import { Box, Grid, Typography, useTheme } from "@material-ui/core";
import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useContext } from "react";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import IconTitle from "../../../../../shared/components/IconTitle";
import MainButton from "../../../../../shared/components/MainButton";
import Text from "../../../../../shared/components/Text";

export function CardSummaryWrapper({
  handleRequestLoanOrShowOptinsDialog,
  getValues,
  ConditionsComponent,
}) {
  const {
    state: { flowLoading },
  } = useContext(ProcessContext);

  const { palette, customBorderRadius } = useTheme();

  return (
    <>
      <Box
        className="appear-anim"
        style={{
          display: flowLoading.show ? "none" : "block",
        }}
      >
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_LOAN_ADJUST}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId={"GOOD"} />}
          subtitle={<Text tId="YOUR_LOAN_RESULT" />}
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          className="appear-anim"
        ></Box>
        <Box mt={2} />
        <Box
          p={3}
          m={1}
          borderRadius={customBorderRadius.paper}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          bgcolor={palette.dark.main}
          color={palette.dark.contrastText}
          style={{
            maxHeight: "200px",
          }}
        >
          <Grid
            container
            display="flex"
            alignItems="center"
            justifyContent="space-around"
            spacing={2}
          >
            {ConditionsComponent}
          </Grid>
        </Box>
      </Box>
      <Box />
      <Box>
        <Box display={"flex"} flexDirection={"row"} gridGap={8}>
          <i
            className="material-icons-outlined"
            style={{
              fontSize: 14,
              paddingTop: "2px",
              marginLeft: "6px",
              color: palette.warning.main,
            }}
          >
            info
          </i>
          <Typography variant="caption" color="textSecondary">
            <Text tId="APPLY_FOR_LOAN_BODY" />
          </Typography>
        </Box>
        <MainButton
          onClick={() => handleRequestLoanOrShowOptinsDialog(getValues())}
        >
          <Text tId="APPLY_FOR_LOAN" />
        </MainButton>
      </Box>
    </>
  );
}
